import React from 'react';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { MyCpgPodsSettings } from '../mycpg-pod-models';


interface Props {
	settings: MyCpgPodsSettings;
}

export function PodGrid(props: React.PropsWithChildren<Props>) {

	const { settings } = props;
	return (
		<>
			<ContentSpacer>
				<p>{settings?.podGridHelperText}</p>
			</ContentSpacer>
			<DividerSection removeDivider sectionText={settings?.podGridTitle}>
				<div className='pods-benefits-grid'>
					{props.children}
				</div>
			</DividerSection>
		</>
	);
}